var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinsentWelcome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 125,
    viewBox: "0 0 89 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_67)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 932,
    transform: "translate(-171 -257)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1587 21.5518L87.6939 82.208L35.8623 52.2822L88.1587 21.5518Z",
    fill: "#123262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3418 121.92L31.808 61.2651L83.6382 91.1895L31.3418 121.92Z",
    fill: "#123262"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1388 11.6782L16.8251 52.8455L0.25 36.7732L62.9804 0L87.1388 11.6782Z",
    fill: "#123262"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.608 49.0202V125L0.25 108.994V36.5864L22.608 49.0202Z",
    fill: "#225CB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 932,
    fill: "white",
    transform: "translate(-171 -257)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinsentWelcome);
export default __webpack_public_path__ + "static/media/finsent-welcome.633d0f5a626219e872400fae6ecff5d5.svg";
export { ForwardRef as ReactComponent };